import React from "react";
import {BASE_URL, validateEmail, hideAlertAfterDelay} from "../../helper";
import API from "../../api";
import "../../assets/css/notification.css";
import "../../assets/css/input.css";
import "../../assets/css/errors.css";
import "react-phone-number-input/style.css";
import {Helmet} from "react-helmet";
import GoogleMapReact from 'google-map-react';
import MapFlag from "./mapFlag";
import {withSnackbar} from "notistack";
import {selectStore} from "../../actions/store";
import {connect} from "react-redux";
import {Modal} from "react-bootstrap";
import {Cookies, withCookies} from "react-cookie";
import {instanceOf} from "prop-types";
import {updateCart} from "../../actions/cart";
import {setUserInfo} from "../../actions/user";
import PhoneInput from "react-phone-input-2";
import {images} from "../../constant";
import ShopHoursClass from "../Common/Timing";
import Promotion from "./Promotion";

const api = new API();

class FindStore extends React.Component {

    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            disabled: false,
            showDropdown: null,
            contactLocationMenuOpen: false,
            Data: {
                name: "",
                email: "",
                contact_no: "",
                message: "",
                restaurant_inquiry_for: ""
            },
            errors: {},
            touched: this.getInitialTouchedState(),
            errorAlert: null,
            center: {
                lat: 29.6672782,
                lng: -95.35597050000001
            },
            zoom: 10.5,
            available_item_count: 0,
            default_store: null,
            changed_restaurant: null,
            confirm_reset_cart: false,
            requested_store: 1,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleEvenPhone = this.handleEvenPhone.bind(this);
        this.handleRestaurantChange = this.handleRestaurantChange.bind(this);
        this.handleLocationSelect = this.handleLocationSelect.bind(this);
        this.handleLocationDropdownBlur = this.handleLocationDropdownBlur.bind(this);
        this.fullNameRef = React.createRef();
        this.phoneRef = React.createRef();
        this.emailRef = React.createRef();
        this.messageRef = React.createRef();
        this.restaurantRef = React.createRef();
        this.alertBox = React.createRef();
    }

    getContactFieldNames() {
        return ["restaurant_inquiry_for", "name", "email", "contact_no", "message"];
    }

    getInitialTouchedState() {
        return this.getContactFieldNames().reduce((touched, name) => {
            touched[name] = false;
            return touched;
        }, {});
    }

    getAllTouchedState() {
        return this.getContactFieldNames().reduce((touched, name) => {
            touched[name] = true;
            return touched;
        }, {});
    }

    // Keep submit, blur, and change-after-blur validation aligned for the contact form.
    getFieldValidationError(name, value) {
        const fieldValue = value === null || value === undefined ? "" : value.toString().trim();

        if (name === "restaurant_inquiry_for") {
            return !fieldValue ? "Select location" : "";
        }

        if (name === "name") {
            return !fieldValue ? "Enter full name" : "";
        }

        if (name === "email") {
            return !fieldValue || !validateEmail(fieldValue) ? "Enter valid email address" : "";
        }

        if (name === "contact_no") {
            return fieldValue && fieldValue.length < 10 ? "Enter valid phone number" : "";
        }

        if (name === "message") {
            return !fieldValue ? "Enter message" : "";
        }

        return "";
    }

    getFormValidationErrors(data = this.state.Data) {
        const errors = {};

        this.getContactFieldNames().forEach((name) => {
            const error = this.getFieldValidationError(name, data[name]);

            if (error) {
                errors[name] = error;
            }
        });

        return errors;
    }

    getUpdatedErrors(name, value, errors = this.state.errors) {
        const updatedErrors = {...errors};
        const fieldError = this.getFieldValidationError(name, value);

        if (fieldError) {
            updatedErrors[name] = fieldError;
        } else {
            delete updatedErrors[name];
        }

        return updatedErrors;
    }

    getFieldRef(name) {
        return {
            restaurant_inquiry_for: this.restaurantRef,
            name: this.fullNameRef,
            email: this.emailRef,
            contact_no: this.phoneRef,
            message: this.messageRef,
        }[name];
    }

    scrollToFirstError(errors) {
        const firstErrorName = this.getContactFieldNames().find((name) => errors[name]);
        const ref = this.getFieldRef(firstErrorName);

        if (ref?.current) {
            ref.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    }

    componentDidMount() {

        window.scrollTo(0, 0);

        if (this.props.defaultStore != null) {
            this.setState({
                default_store: this.props.defaultStore.store ? this.props.defaultStore.store : null,
            });
        }

        if (this.props.cartAddedItems.cartItems != null) {
            this.setState({available_item_count: this.props.cartAddedItems.cartItems.length})
        }

        if (this.props.getUserInfo != null &&
            this.props.getUserInfo.info !== undefined &&
            this.props.getUserInfo.info.length > 0 &&
            this.props.getUserInfo.info.data.user !== undefined
        ) {
            this.setState({
                Data: {
                    ...this.state.Data,
                    name: this.props.getUserInfo.info.data.user.first_name + " " + this.props.getUserInfo.info.data.user.last_name,
                    email: this.props.getUserInfo.info.data.user.email,
                    contact_no: this.props.getUserInfo.info.data.user.mobile,
                },
            });
        } else {
            api.authME(
                this.props.cookies.get("token")
                    ? this.props.cookies.get("token")
                    : null
            )
                .then((success) => {
                    this.props.userInfo({user: success.data.response});
                });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.defaultStore !== prevProps.defaultStore) {
            this.setState({
                default_store: this.props.defaultStore.store ? this.props.defaultStore.store : null,
            });
        }

        if (this.props.cartAddedItems.cartItems != null && this.state.available_item_count !== this.props.cartAddedItems.cartItems.length) {
            this.setState({available_item_count: this.props.cartAddedItems.cartItems.length})
        }

        if (prevProps.getUserInfo !== this.props.getUserInfo) {
            this.setState({
                Data: {
                    ...this.state.Data,
                    name: this.props.getUserInfo.info.data.user.first_name + " " + this.props.getUserInfo.info.data.user.last_name,
                    email: this.props.getUserInfo.info.data.user.email,
                    contact_no: this.props.getUserInfo.info.data.user.mobile,
                },
            });
        }
    }

    handleConfirmChange() {
        api.clearCart(this.props.cookies.get('cart_id') ? this.props.cookies.get('cart_id') : 'blank',
            this.props.cookies.get('token') ? this.props.cookies.get('token') : null).then(cart => {
            this.setState({confirm_reset_cart: false}, () => {
                this.props.updateCartItems({
                    cart_id: this.props.cookies.get('cart_id') ? this.props.cookies.get('cart_id') : 'blank',
                    token: this.props.cookies.get('token') ? this.props.cookies.get('token') : null
                });
                setTimeout(
                    function () {
                        this.props.defStore(this.state.changed_restaurant);
                        this.props.history.push('/');
                    }
                        .bind(this),
                    500
                );
            });
        });
    }

    handleConfirmCancel() {
        this.setState({confirm_reset_cart: false});
    }

    handleRestaurantChange(val) {

        if (val === 1) {
            var data = {
                store: 1,
                address: "Farmer’s Fresh Meat at Cullen",
                preference: 2,
                delivery: {address: "8630 Cullen Blvd, Houston, TX 77051", zip_code: "77051"}
            };
        }
        if (val === 2) {
            var data = {
                store: 2,
                address: "Farmer’s Fresh Meat at Mesa",
                preference: 2,
                delivery: {address: "9541 Mesa Dr. Houston, TX 77078", zip_code: "77078"}
            };
        }
        if (this.state.available_item_count > 0) {
            if (this.state.default_store !== val) {
                this.setState({confirm_reset_cart: true, changed_restaurant: data, requested_store: val})
            } else {
                this.props.defStore(data);
                this.props.history.push('/');
            }
        } else {
            this.props.defStore(data);
            this.props.history.push('/');
        }
    }

    handleChange(event) {
        const {name, value} = event.target;
        const Data = {
            ...this.state.Data,
            [name]: value,
        };
        const errors = this.state.touched[name] || this.state.errors[name]
            ? this.getUpdatedErrors(name, value)
            : this.state.errors;

        this.setState({Data, errors, disabled: false});
    }

    handleEvenPhone(event) {
        const Data = {
            ...this.state.Data,
            contact_no: event,
        };
        const errors = this.state.touched.contact_no || this.state.errors.contact_no
            ? this.getUpdatedErrors("contact_no", event)
            : this.state.errors;

        this.setState({Data, errors, disabled: false});
    }

    getLocationOptions() {
        return [
            {value: "1", label: "Farmer’s Fresh Meat at Cullen"},
            {value: "2", label: "Farmer’s Fresh Meat at Mesa"},
            {value: "3", label: "All of the above"},
        ];
    }

    getSelectedLocationLabel() {
        const selectedLocation = this.getLocationOptions().find((option) => option.value === this.state.Data.restaurant_inquiry_for);
        return selectedLocation ? selectedLocation.label : "Select";
    }

    handleLocationSelect(value) {
        const errors = this.state.touched.restaurant_inquiry_for || this.state.errors.restaurant_inquiry_for
            ? this.getUpdatedErrors("restaurant_inquiry_for", value)
            : this.state.errors;

        this.setState({
            contactLocationMenuOpen: false,
            disabled: false,
            errors,
            Data: {
                ...this.state.Data,
                restaurant_inquiry_for: value,
            },
        });
    }

    handleLocationDropdownBlur(event) {
        if (!event.currentTarget.contains(event.relatedTarget)) {
            this.setState({
                contactLocationMenuOpen: false,
                touched: {
                    ...this.state.touched,
                    restaurant_inquiry_for: true,
                },
                errors: this.getUpdatedErrors("restaurant_inquiry_for", this.state.Data.restaurant_inquiry_for),
            });
        }
    }

    handleBlur(event) {
        const {name} = event.target;

        this.setState({
            touched: {
                ...this.state.touched,
                [name]: true,
            },
            errors: this.getUpdatedErrors(name, this.state.Data[name]),
        });
    }

    handleSubmit(event) {

        this.setState({
            errorAlert: null,
            disabled: true
        });
        event.preventDefault();

        const errors = this.getFormValidationErrors();

        if (Object.keys(errors).length > 0) {
            this.setState({
                errors,
                touched: this.getAllTouchedState(),
                disabled: false,
            });
            this.scrollToFirstError(errors);
            return false;
        }

        api.contactUs(this.state.Data)
            .then((success) => {
                this.setState({
                    disabled: false,
                    errors: {},
                    touched: this.getInitialTouchedState(),
                    Data: {
                        name: "",
                        email: "",
                        contact_no: "",
                        message: "",
                        restaurant_inquiry_for: ""
                    },
                    errorAlert: "Thank you for your message. A Farmer's Fresh Team Member will get back with you shortly!",
                });

                this.alertBox.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });

                // clear previous timer
                if (this.alertTimeout) {
                    clearTimeout(this.alertTimeout);
                }
            
                // start new timer
                this.alertTimeout = hideAlertAfterDelay(() => {
                    this.setState({ errorAlert: null });
                });
            })
            .catch((error) => {

                this.alertBox.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
                this.setState({
                    disabled: false,
                    errorAlert: error.response.data.message,
                });

                // clear previous timer
                if (this.alertTimeout) {
                    clearTimeout(this.alertTimeout);
                }
            
                // start new timer
                this.alertTimeout = hideAlertAfterDelay(() => {
                    this.setState({ errorAlert: null });
                });
            });
    }

    createMapOptions(maps) {
        return {
            zoomControlOptions: {
                position: maps.ControlPosition.RIGHT_CENTER,
                style: maps.ZoomControlStyle.SMALL
            },
            mapTypeControlOptions: {
                position: maps.ControlPosition.TOP_RIGHT
            },
            mapTypeControl: true
        };
    }

    handleDropDownClick(type = '') {
        this.setState({
            showDropdown: type
        });
        setTimeout(() => {
            this.setState({
                showDropdown: null
            });
        }, 500)
    }

    render() {

        const {showDropdown} = this.state || {};

        return (
            <>
                <React.Fragment>
                    <Helmet>
                        <meta charSet="utf-8"/>
                        <title>Farmer's Fresh Meat - Contact-Us</title>
                        <meta name="description"
                              content="Farmer's Fresh Meat is proud to be the best butcher shop and meat market in Houston, Texas. Buy wholesale beef, goat meat, chicken, and more - on sale now!"/>
                        <meta name="robots" content="index, follow"/>
                        <meta name="googlebot"
                              content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"/>
                        <meta property="og:type" content="article"/>
                        <meta property="og:title"
                              content="Farmer's Fresh Meat - Voted Best Meat Market/Butcher Shop in Houston"/>
                        <meta property="og:description"
                              content="Farmer's Fresh Meat is proud to be the best butcher shop and meat market in Houston, Texas. Buy wholesale beef, goat meat, chicken, and more - on sale now!"/>
                        <meta property="og:url" content={BASE_URL() + this.props.location.pathname}/>
                        <meta property="og:site_name"
                              content="Farmer&#039;s Fresh Meat: Houston Meat Market &amp; Butcher Shop"/>
                        <meta property="article:publisher" content="https://www.facebook.com/farmersfreshmeat"/>
                        <meta property="article:modified_time" content="2022-02-28T13:10:39+00:00"/>
                        <meta property="og:image" content={images.logoImg}/>
                        <meta property="og:image:width" content="1449"/>
                        <meta property="og:image:height" content="1024"/>
                        <meta name="twitter:card" content="summary"/>
                        <meta name="twitter:creator" content="Farmerfreshmeat"/>
                        <meta name="twitter:site" content="Farmerfreshmeat"/>
                        <link rel="canonical" href={BASE_URL() + this.props.location.pathname}/>
                        <script type="application/ld+json"
                                className="yoast-schema-graph">{` {"@context":"https://schema.org","@graph":[{"@type":"Organization","@id":"https://farmersfreshmeat.com/#organization","name":"Farmer's Fresh Meat","url":"https://farmersfreshmeat.com/","sameAs":["https://www.facebook.com/farmersfreshmeat","https://www.instagram.com/farmersfreshmeat/","https://www.youtube.com/user/farmersfreshmeat","https://www.pinterest.com/Farmerfreshmeat/","https://twitter.com/Farmerfreshmeat"],"logo":{"@type":"ImageObject","@id":"https://farmersfreshmeat.com/#logo","inLanguage":"en-US","url":"https://farmersfreshmeat.com/wp-content/uploads/2015/03/Farmers_Fresh_Meat_Logo.png","width":312,"height":79,"caption":"Farmer's Fresh Meat"},"image":{"@id":"https://farmersfreshmeat.com/#logo"}},{"@type":"WebSite","@id":"https://farmersfreshmeat.com/#website","url":"https://farmersfreshmeat.com/","name":"Farmer&#039;s Fresh Meat: Houston Meat Market &amp; Butcher Shop","description":"Farmers Fresh Meat","publisher":{"@id":"https://farmersfreshmeat.com/#organization"},"potentialAction":[{"@type":"SearchAction","target":"https://farmersfreshmeat.com/?s={search_term_string}","query-input":"required name=search_term_string"}],"inLanguage":"en-US"},{"@type":"ImageObject","@id":"https://farmersfreshmeat.com/shop/leg-quarters/#primaryimage","inLanguage":"en-US","url":"https://farmersfreshmeat.com/wp-content/uploads/2019/09/Leg-Quarters-3-scaled.jpg","width":1449,"height":1024},{"@type":"WebPage","@id":"https://farmersfreshmeat.com/shop/leg-quarters/#webpage","url":"https://farmersfreshmeat.com/shop/leg-quarters/","name":"Fresh Chicken Leg Quarters By the Pound - On Sale now!","isPartOf":{"@id":"https://farmersfreshmeat.com/#website"},"primaryImageOfPage":{"@id":"https://farmersfreshmeat.com/shop/leg-quarters/#primaryimage"},"datePublished":"2019-09-23T15:14:32+00:00","dateModified":"2022-02-28T13:10:39+00:00","description":"Fresh Chicken Leg Quarters on Sale and Priced per pound. Hormone free and cut free of charge. The best price and quality at Farmer's Fresh Meat!","inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://farmersfreshmeat.com/shop/leg-quarters/"]}]}]}`}</script>
                    </Helmet>
                    <div className="col-md-12 ">
                        <div className="breadcrumb-details">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active" aria-current="page"><a>Location & hours</a>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <div className="col-md-12 ">
                        <div style={{height: "450px", width: '100%'}}>
                            <GoogleMapReact
                                bootstrapURLKeys={{key: "AIzaSyBhlm5dfswCn3ePLbHgiV1EuQ48k9SdYCw"}}
                                defaultCenter={this.state.center}
                                defaultZoom={this.state.zoom}
                                options={this.createMapOptions}

                            >
                                <MapFlag
                                    lat={29.6672782}
                                    lng={-95.35597050000001}
                                    text="Cullen"
                                />

                                <MapFlag
                                    lat={29.85250139999999}
                                    lng={-95.25277410000001}
                                    text="Mesa"
                                />
                            </GoogleMapReact>
                        </div>
                    </div>

                    <div className="container location px-0 mt-4 pt-3 mb-fix">
                        <div className="col-12">
                            <div className="row align-items-center justify-content-center">
                                <div className="col-md-12">
                                    <div className="title px-0"><h2>Farmer's location & hours</h2></div>
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="row">
                                                    <div className="col-md-12 p-0">
                                                        <div className="col-12  main-section bg-white py-4 address mb-4">
                                                            <div className="col-12 py-1 px-0">
                                                                <h2 className="mb-3">Farmer’s Fresh Meat on Cullen</h2>
                                                                <div className="footer-content mt-2">
                                                                    <div className="contact-details">
                                                                        <div className="row">
                                                                            <div className="col-auto icons">
                                                                                <i className="fa fa-clock-o"
                                                                                   aria-hidden="true"></i>
                                                                            </div>
                                                                            <div className="col pl-0">
                                                                                <div className="hours-details p-0">
                                                                                    <h6 onClick={() => {
                                                                                        this.handleDropDownClick('cullen');
                                                                                    }} className='pointer text-timing'>Hours of
                                                                                        Operation</h6>
                                                                                    <ShopHoursClass showDropdown={showDropdown === 'cullen'}
                                                                                        shopOpenId='findStoreCullenShopOpen'
                                                                                        shopCloseId='findStoreCullenShopClose'/>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div className="row">
                                                                            <div className="col-auto icons">
                                                                                <i className="fa fa-map-marker"
                                                                                   aria-hidden="true"></i>
                                                                            </div>
                                                                            <div className="col pl-0">
                                                                                <div className="hours-details p-0">
                                                                                    <h6>8630 Cullen Blvd<br/>
                                                                                        Houston, TX 77051
                                                                                    </h6>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="row">
                                                                            <div className="col-auto icons">
                                                                                <i className="fa fa-phone"></i>
                                                                            </div>
                                                                            <div className="col pl-0">
                                                                                <div className="hours-details p-0 mb-0">
                                                                                    <h6>(713) 715-5051</h6>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="d-flex align-items-center mt-3 mb-1">
                                                                    <button className="btn btn-order px-4 py-2 mt-0"
                                                                            onClick={() => {
                                                                                this.handleRestaurantChange(1);
                                                                            }}>Shop now
                                                                    </button>
                                                                    <a target="_blank"
                                                                       href="https://maps.google.com/?daddr=8630%20Cullen%20Blvd,%20Houston,%20TX%2077051&saddr=Current%20Location"
                                                                       className="ml-3">Get directions</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <hr/>
                                                    <div className="col-md-12 p-0">
                                                        <div className="col-12 main-section bg-white py-4 address mb-0">
                                                            <div className="col-12 py-1 px-0">
                                                                <h2 className="mb-3">Farmer’s Fresh Meat on Mesa</h2>
                                                                <div className="footer-content mt-2">
                                                                    <div className="contact-details">
                                                                        <div className="row">
                                                                            <div className="col-auto icons">
                                                                                <i className="fa fa-clock-o"
                                                                                   aria-hidden="true"></i>
                                                                            </div>
                                                                            <div className="col pl-0">
                                                                                <div className="hours-details p-0">
                                                                                    <h6 onClick={() => {
                                                                                        this.handleDropDownClick('mesa');
                                                                                    }} className='pointer text-timing'>Hours of
                                                                                        Operation</h6>
                                                                                    <ShopHoursClass showDropdown={showDropdown === 'mesa'}
                                                                                        shopOpenId='findStoreMesaOpen'
                                                                                        shopCloseId='findStoreMesaClose'/>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div className="row">
                                                                            <div className="col-auto icons">
                                                                                <i className="fa fa-map-marker"
                                                                                   aria-hidden="true"></i>
                                                                            </div>
                                                                            <div className="col pl-0">
                                                                                <div className="hours-details p-0">
                                                                                    <h6>9541 Mesa Dr.<br/>Houston, TX 77078</h6>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="row">
                                                                            <div className="col-auto icons">
                                                                                <i className="fa fa-phone"></i>
                                                                            </div>
                                                                            <div className="col pl-0">
                                                                                <div className="hours-details p-0 mb-0">
                                                                                    <h6>(713) 715-5051</h6>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="d-flex align-items-center mt-3 mb-1">
                                                                    <button className="btn btn-order px-4 py-2 mt-0"
                                                                            onClick={() => {
                                                                                this.handleRestaurantChange(2);
                                                                            }}>Shop now
                                                                    </button>
                                                                    <a target="_blank"
                                                                       href="https://maps.google.com/?daddr=9541%20Mesa%20Dr.%20Houston,%20TX%2077078&saddr=Current%20Location"
                                                                       className="ml-3">Get directions</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6 form-group px-0 pl-sm-4 mt-3 mt-sm-0 mb-0">
                                                <div className="col-12 main-section bg-white px-3 py-4 mb-3 mb-md-2">
                                                    <div className="row">
                                                        <div className="title pl-4 mb-2"><h2>Contact us</h2></div>
                                                        {this.state.errorAlert ? (
                                                            <div className="col-12 px-4">
                                                                <div
                                                                    ref={this.alertBox}
                                                                    role="alert"
                                                                    className="sc-1wz9i2x-0 fooVeKSuccess align-items-start mt-1"
                                                                >
                                                                    <svg viewBox="0 0 512 512"
                                                                         className="text-success w-16 mr-2">
                                                                        <path
                                                                            d="M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM371.8 211.8C382.7 200.9 382.7 183.1 371.8 172.2C360.9 161.3 343.1 161.3 332.2 172.2L224 280.4L179.8 236.2C168.9 225.3 151.1 225.3 140.2 236.2C129.3 247.1 129.3 264.9 140.2 275.8L204.2 339.8C215.1 350.7 232.9 350.7 243.8 339.8L371.8 211.8z"/>
                                                                    </svg>
                                                                    <div className="text-message">
                                                                        <h6>Thank you for your message.</h6>
                                                                        <p>A Farmer's Fresh Team Member will get back with
                                                                            you shortly!</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : null}

                                                        <div ref={this.restaurantRef} className="col-md-12 mb-3 fields px-4">
                                                            <label htmlFor="exampleInputFirstName" className="form-label">
                                                                Select location *
                                                            </label>
                                                            <div className={"contact-location-select " + (this.state.errors.restaurant_inquiry_for ? "invalid" : "")}
                                                                 onBlur={this.handleLocationDropdownBlur}>
                                                                <button
                                                                    type="button"
                                                                    className="form-control valid-control contact-location-select-toggle"
                                                                    aria-haspopup="listbox"
                                                                    aria-expanded={this.state.contactLocationMenuOpen}
                                                                    onClick={() => {
                                                                        this.setState({contactLocationMenuOpen: !this.state.contactLocationMenuOpen});
                                                                    }}
                                                                >
                                                                    <span>{this.getSelectedLocationLabel()}</span>
                                                                </button>
                                                                {this.state.contactLocationMenuOpen &&
                                                                <div className="contact-location-select-menu" role="listbox">
                                                                    <button
                                                                        type="button"
                                                                        className="contact-location-select-option placeholder"
                                                                        disabled
                                                                    >
                                                                        Select
                                                                    </button>
                                                                    {this.getLocationOptions().map((option) => (
                                                                        <button
                                                                            key={option.value}
                                                                            type="button"
                                                                            role="option"
                                                                            aria-selected={this.state.Data.restaurant_inquiry_for === option.value}
                                                                            className={"contact-location-select-option " + (this.state.Data.restaurant_inquiry_for === option.value ? "selected" : "")}
                                                                            onClick={() => this.handleLocationSelect(option.value)}
                                                                        >
                                                                            {option.label}
                                                                        </button>
                                                                    ))}
                                                                </div>
                                                                }
                                                            </div>
                                                            <span className="error-text mt-1">
                                                                {this.state.errors.restaurant_inquiry_for}
                                                            </span>
                                                        </div>

                                                        <div ref={this.fullNameRef} className="col-md-12 mb-3 fields px-4">
                                                            <label
                                                                htmlFor="exampleInputFirstName"
                                                                className="form-label"
                                                            >
                                                                Full name *
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className={"form-control valid-control " + (this.state.errors.name ? " invalid" : "")}
                                                                name="name"
                                                                placeholder="Enter full name"
                                                                value={this.state.Data.name}
                                                                onChange={this.handleChange}
                                                                onBlur={this.handleBlur}
                                                            />
                                                            <span className="error-text mt-1">
                                                    {this.state.errors.name}
                                                  </span>
                                                        </div>
                                                        <div ref={this.emailRef} className="col-md-12 mb-3 fields px-4">
                                                            <label htmlFor="exampleInputFirstName" className="form-label">
                                                                Email *
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className={"form-control valid-control " + (this.state.errors.email ? " invalid" : "")}
                                                                placeholder="Email address"
                                                                name="email"
                                                                value={this.state.Data.email}
                                                                onChange={this.handleChange}
                                                                onBlur={this.handleBlur}
                                                            />
                                                            <span className="error-text mt-1">
                                                    {this.state.errors.email}
                                                  </span>
                                                        </div>
                                                        <div ref={this.phoneRef} className="col-md-12 mb-3 fields px-4">
                                                            <label
                                                                htmlFor="exampleInputFirstName"
                                                                className="form-label"
                                                            >
                                                                Phone
                                                            </label>
                                                            {/*<input*/}
                                                            {/*    maxLength="10"*/}
                                                            {/*    minLength="10"*/}
                                                            {/*    name="contact_no"*/}
                                                            {/*    className="form-control"*/}
                                                            {/*    placeholder="Enter phone number"*/}
                                                            {/*    value={this.state.Data.contact_no}*/}
                                                            {/*    onChange={this.handleChange}*/}
                                                            {/*/>*/}

                                                            <PhoneInput
                                                                placeholder="Enter phone number"
                                                                inputClass={"valid-control " + (this.state.errors.contact_no ? "invalid" : "")}
                                                                country={'us'}
                                                                disableCountryGuess={true}
                                                                disableCountryCode={true}
                                                                disableDropdown={true}
                                                                value={this.state.Data.contact_no}
                                                                onChange={this.handleEvenPhone}
                                                                onBlur={() => this.handleBlur({target: {name: "contact_no"}})}
                                                            />
                                                            <span className="error-text mt-1">
                                                                {this.state.errors.contact_no}
                                                            </span>

                                                        </div>
                                                        <div ref={this.messageRef} className="col-md-12 mb-3 fields px-4">
                                                            <label htmlFor="exampleInputFirstName" className="form-label">
                                                                Message *
                                                            </label>
                                                            <textarea
                                                                className={"form-control valid-control " + (this.state.errors.message ? " invalid" : "")}
                                                                name="message"
                                                                value={this.state.Data.message}
                                                                onChange={this.handleChange}
                                                                onBlur={this.handleBlur}
                                                            >
                                                </textarea>
                                                            <span className="error-text mt-1">
                                                    {this.state.errors.message}
                                                  </span>
                                                        </div>
                                                        <div className="col-md-12 fields px-4">
                                                            <button disabled={this.state.disabled}
                                                                    className="btn btn-order py-2 px-4"
                                                                    onClick={(e) => this.handleSubmit(e)}>Send
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="promo-export px-3">
                            <Promotion home={true} slider={true} />
                        </div>
                    </div>


                    <Modal onHide={() => {
                        this.setState({confirm_reset_cart: false});
                    }} show={this.state.confirm_reset_cart} className="storeModal mt-5">
                        <Modal.Body>
                            <div className="modal-body">
                                <div className="col-12 p-0">
                                    <h2 className="card-heading w-100 mt-1 mb-3">
                                        Shop at Farmer's Fresh Meat
                                        at {this.state.requested_store === 2 ? "Mesa" : "Cullen"}</h2>
                                    <h6 className="w-100 mb-1 card-text">Changing restaurant may remove items from your
                                        cart according to availability at selected location..</h6>
                                    {/*<h6 className="w-100 mb-0 card-text">Please confirm to continue.</h6>*/}
                                </div>
                                <hr/>
                                <div className="mt-1">
                                    <button onClick={() => this.handleConfirmChange()}
                                            className="btn btn-s proceed-button btn-success mb-3 mb-sm-0"
                                            style={{
                                                color: '#000',
                                                transition: 'all .3s ease-in-out'
                                            }}>Confirm
                                    </button>
                                    <button onClick={() => this.handleConfirmCancel()}
                                            className="btn btn-s cart-button ">Cancel
                                    </button>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>
                </React.Fragment>
            </>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        defaultStore: state.StoreReducer.selectedStore,
        cartAddedItems: state.CartReducer.cartItems,
        getUserInfo: state.UserReducer,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        defStore: (val) => dispatch(selectStore({type: 'SELECTED_STORE', data: val})),
        updateCartItems: (val) => dispatch(updateCart({type: 'UPDATE_CART_ITEMS', data: val})),
        userInfo: (data) => dispatch(setUserInfo({type: "GET_USER_INFO", data: data})),
    }
};

export default withSnackbar(withCookies(connect(mapStateToProps, mapDispatchToProps)(FindStore)));
